import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled";
import {
  Avatar,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Card as MuiCard,
  CardActions,
  CardContent as MuiCardContent,
  CardMedia as MuiCardMedia,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography as MuiTypography,
  AvatarGroup as MuiAvatarGroup,
} from "@mui/material";
import { spacing } from "@mui/system";
import useReferentiel from "hooks/useReferentiel";
import RefsList from "./RefsList";
import RefsEditBtn from "./RefsEditBtn";
import PaginationRefsGrid from "./PaginationRefsGrid";
// ----------------------------------------------------------------------
const Typography = styled(MuiTypography)(spacing);

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

export default function RefsSubjectPage() {
  const { refs } = useReferentiel();

  if (!refs) return <></>;
  const { refSubject } = refs;
  if (!refSubject) return <></>;
  return (
    <>
      <Helmet title="Gestion des sujets" />

      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Sujets
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/app">
              Accueil
            </Link>
            <Typography>Sujets</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item>
          <RefsEditBtn refName="refsubject" addLabel="Nouveau sujet" />
        </Grid>
      </Grid>

      <Divider my={6} />
      <PaginationRefsGrid filteredItems={refSubject} refName="refsubject" />

      {/* <Grid container spacing={6}><RefsList items={refsubject} refName="refsubject" />  </Grid>*/}
    </>
  );
}
